/** Standard API parameter and envelope schemas */

import { z } from 'zod'

/** Standard error response schema */
export const errorResponseSchema = z.object({
  error: z.string(),
  code: z.string().optional(),
})

/** Standard success message schema */
export const messageResponseSchema = z.object({
  message: z.string(),
})

/** Standard UUID / ID path parameter */
export const idParamSchema = z.object({
  id: z.string().min(1).describe('Resource identifier'),
})

/** Standard slug path parameter */
export const slugParamSchema = z.object({
  slug: z.string().min(1).describe('URL slug'),
})

/** Standard pagination query parameters */
export const paginationQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20).optional(),
  offset: z.coerce.number().int().min(0).default(0).optional(),
})
